import { render, staticRenderFns } from "./GenericDocumentModal.vue?vue&type=template&id=17518256&scoped=true"
import script from "./GenericDocumentModal.vue?vue&type=script&lang=ts"
export * from "./GenericDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./GenericDocumentModal.vue?vue&type=style&index=0&id=17518256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17518256",
  null
  
)

export default component.exports